import { graphql } from "@/lib/gql/__generated__/gql";

export const PLAIN_WIDGET_FOR_DESIGN_PLAIN_MUTATION = graphql(/* GraphQL */ `
	mutation PlainWidgetForDesignPlainUpdate($input: PlainWidgetInput!) {
		plainWidgetUpdate(input: $input) {
			userErrors
			plainWidget {
				id
				hotelID
				widgetItems {
					widgetID
					contentID
					widgetType
					title
				}
			}
		}
	}
`);
